import { render } from "./ButtonElement.vue?vue&type=template&id=0094f964"
import script from "./ButtonElement.vue?vue&type=script&lang=js"
export * from "./ButtonElement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__